import io from 'socket.io-client';
import configLoader from '@/runtime-config-loader';

export interface Chat {
    sessionId: string,
    clientId: string,
    clientName: string,
    creationTime: Date,
    lastMessageTime?: Date,
    messages: Array<{
        text: string,
        senderRole: "CLIENT"|"PHOTOGRAPHER",
        isRead: boolean
    }>
};

export interface ChatMessage {
    clientId: string;
    sessionId: string;
    text: string;
}
export type chatListListener = (chats: Chat[]) => void;
export type messageListener = (message: ChatMessage) => void;
export type chatCreatedListener = (chat: Chat) => void;

let messageListeners: messageListener[] = [];
let chatListListeners: chatListListener[] = [];
const chatCreatedListeners: chatCreatedListener[] = [];

let socket: SocketIOClient.Socket;

function mapDates(c: Chat) {
    if (c.creationTime) {
        c.creationTime = new Date(c.creationTime);
    }
    if (c.lastMessageTime) {
        c.lastMessageTime = new Date(c.lastMessageTime);
    }

    return c;
}
export default {
    async connect() {
        const config = await configLoader;
        if (socket) {
            this.disconnect();
        }
        socket = io.connect(config.chatUrl);
        socket.on('chatList', (chatList: Chat[]) => {
            const mappedList = chatList.map(c => mapDates(c));
            chatListListeners.forEach(
                l => l(mappedList)
            )
        });
        socket.on('receiveMessage', (message: ChatMessage) => messageListeners.forEach(l => l(message)));
        socket.on('chatCreated', (chat: Chat) => chatCreatedListeners.forEach(
            l => l(mapDates(chat))
        ));
    },

    async disconnect() {
        this.clearListeners();
        if (socket) {
            await socket.disconnect();
        }
    },

    clearListeners() {
        messageListeners = [];
        chatListListeners = [];
    },

    registerMessageListener(listener: messageListener) {
        messageListeners.push(listener);
    },

    registerChatListListener(listener: chatListListener) {
        chatListListeners.push(listener);
    },

    registerChatCreatedListener(listener: chatCreatedListener) {
        chatCreatedListeners.push(listener);
    },

    requestChats(sessionIds: string[]) {
        socket.emit('requestChats', sessionIds);
    },

    async sendMessage(message: ChatMessage) {
        socket.emit('sendMessage', message);
    },

    async setChatRead(sessionId: string, clientId: string) {
        socket.emit('setChatReadByPhotographer', { sessionId, clientId });
    }
}
